// evercookie values must stay ASCII-safe: bytes >= 0x80 get mangled by the
// png/cache/etag round-trip (cookies bloat into KBs of mojibake). The device
// uuid is therefore written base64-encoded and validated back on read.
// Anything that fails validation is treated as absent -> a fresh uuid is
// written over every backend on the next visit (self-healing, no manual
// cookie purge needed on client devices).

export const EC_ORDER_ID = "p_x_p_order_id_s";
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function toEver(val) {
    return btoa(val);
}

export function sanitizeEver(raw) {
    if (!raw) {
        return undefined;
    }

    let decoded = raw;
    try {
        const padded = raw + "=".repeat((4 - (raw.length % 4)) % 4);
        decoded = atob(padded);
    } catch (e) {
        // not base64 -> legacy plain value or corrupted mojibake, validated below
    }

    return UUID_RE.test(decoded) ? decoded : undefined;
}

const EVERCOOKIE_COOKIE_NAMES = ["evercookie_cache", "evercookie_etag", "evercookie_png", EC_ORDER_ID];
// a base64 uuid is 48 chars; anything longer is stale/corrupted garbage
const MAX_EVERCOOKIE_VALUE_LENGTH = 128;

// evercookie cache/etag/png responses are cached by the browser for ~20 years,
// so a once-bloated value can keep coming back even after the value is
// rewritten. Drop oversized cookies/stored values before the library votes,
// otherwise the garbage can win the vote (sanitizeEver still catches it, this
// just keeps cookies small and speeds up convergence).
export function purgeOversizedEvercookies() {
    let cookies;
    try {
        cookies = document.cookie;
    } catch (e) {
        // no document access, nothing to purge
        return;
    }

    EVERCOOKIE_COOKIE_NAMES.forEach((name) => {
        const match = cookies.match(new RegExp("(?:^|;\\s*)" + name + "=([^;]*)"));
        if (match && match[1].length > MAX_EVERCOOKIE_VALUE_LENGTH) {
            document.cookie =
                name +
                "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=." +
                window.location.host.replace(/:\d+/, "");
        }
    });

    [window.localStorage, window.sessionStorage].forEach((storage) => {
        try {
            if (storage && (storage.getItem(EC_ORDER_ID) || "").length > MAX_EVERCOOKIE_VALUE_LENGTH) {
                storage.removeItem(EC_ORDER_ID);
            }
        } catch (e) {
            // storage unavailable (private mode), leave it to sanitizeEver
        }
    });
}